export enum ExpectationCopyId {
  CORE = '7sY2Zv5JzMemu4LqSBZPRx',
  FINISHED_WITH_CORE_ONLY = '1bZcJKr9RMolHEnAcXa1qJ',
  FINISHED_WITH_CORE_NEEDS_WORKER_INFO = 'OFrAph6coGFeyChG4eNDy',
}

const expectationContent: Record<string, any> = {
  [ExpectationCopyId.CORE]: {
    headline: 'Welcome {{firstName}}! Let\'s Get Started',
    body: 'Congratulations on joining Bambee! You are now on track to keep your business HR Compliant. The first thing we need to do is get your account properly set up. Don\'t worry, we\'ll help you every step of the way. Once we complete the steps below, you can meet your Dedicated HR Manager and start working in the Bambee platform.',
    nextSteps: [
      'Meet your Dedicated HR Manager',
      'Complete HR Audit',
      'Add company details',
    ],
    whatToPrepare: [
      'Company Details & EIN',
      'Worker Contact & Pay Info',
      'Any existing HR Policies',
    ],
    media: null,
  },
  [ExpectationCopyId.FINISHED_WITH_CORE_ONLY]: {
    headline: 'You\'re All Set, {{firstName}}!',
    body: 'You\'ve completed the core onboarding steps. Your Dedicated HR Manager is ready to help you tackle your most pressing HR needs.',
    nextSteps: [
      'Meet your Dedicated HR Manager',
      'Complete your HR Audit',
      'Review your HR policies',
    ],
    whatToPrepare: [
      'Questions for your HR Manager',
      'Any existing HR documents',
    ],
    media: null,
  },
  [ExpectationCopyId.FINISHED_WITH_CORE_NEEDS_WORKER_INFO]: {
    headline: 'Almost There, {{firstName}}!',
    body: 'You\'ve made great progress! To complete your setup, we just need some information about your workers.',
    nextSteps: [
      'Add your workers',
      'Meet your Dedicated HR Manager',
      'Complete your HR Audit',
    ],
    whatToPrepare: [
      'Worker names and contact info',
      'Worker pay information',
      'Job titles and departments',
    ],
    media: null,
  },
};

export const fetchContent = async (entryId: string) => {
  return expectationContent[entryId] || null;
};

export const formatMediaInfo = (content) =>
  content?.media?.fields?.file
    ? {
        src: content?.media?.fields?.file?.url,
        alt: content?.media?.fields?.description,
      }
    : {};

export default null;
